import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { EB_ICON_TYPE } from '../icons/interface/eb-icon-type.enum'
import { EbGenericPageStep } from './eb-generic-page-stepper.interface'

@Component({
    selector: 'eb-generic-page-stepper',
    templateUrl: './eb-generic-page-stepper.component.html',
    styleUrls: ['./eb-generic-page-stepper.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class EbGenericPageStepperComponent {
  @Input() steps: EbGenericPageStep[]
  @Input() activeStep: number
  @Output() changeStep = new EventEmitter<number>()
  activeStepIndex: number

  get IconType() {
    return EB_ICON_TYPE
  }

  getTabIndex(stepIndex: number): number {
    return !this.isActive(stepIndex) && !this.isDisabled(stepIndex) ? 0 : -1
  }

  isActive(index: number): boolean {
    return index <= this.activeStep
  }

  isDisabled(index: number): boolean {
    return index > this.activeStep
  }
}
